import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s1);
`;

/**
 * One attachment. A button, not a link: it opens the panel's own preview
 * rather than navigating away, and the browser's focus ring and Enter/Space
 * handling come free with the element.
 */
export const Tile = styled.button`
  display: flex;
  align-items: center;
  gap: var(--s2);
  max-width: 220px;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--text-muted);
  cursor: pointer;
  overflow: hidden;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;

  &:hover {
    border-color: var(--primary);
    box-shadow: var(--sh-1);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 1px;
  }
`;

/** The thumbnail itself — a fixed square so a row of them keeps its rhythm. */
export const Image = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  display: block;
  background: var(--surface-alt);
`;

/*
 * What a tile shows when the image will not load.
 *
 * Every image URL in this panel goes through imgproxy and on the dev data
 * every one of them 404s, so this is the common case there rather than an
 * edge one — see `components/thumb`, which makes the same trade for table
 * thumbnails. A broken-image glyph would read as a bug in the panel; a file
 * icon with the attachment's name says what the ticket actually carries, and
 * the tile still opens it.
 */
export const Fallback = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: var(--surface-alt);
  color: var(--text-faint);

  svg {
    width: 22px;
    height: 22px;
    stroke-width: 1.5;
  }
`;

export const Name = styled.span`
  padding-right: var(--s3);
  overflow: hidden;
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text);
`;

/**
 * The preview. The dialog decides the width — it is the panel's 600px card —
 * so this only has to fill it and cap its own height, which is what keeps a
 * portrait photo from running off the bottom of the screen.
 */
export const Preview = styled.img`
  display: block;
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: var(--r-sm);
  background: var(--surface-alt);
`;

/** The preview's own failure state — the modal cannot show a blank box. */
export const PreviewEmpty = styled.div`
  display: grid;
  gap: var(--s2);
  justify-items: center;
  padding: var(--s6) var(--s5);
  font-size: var(--fs-body);
  color: var(--text-muted);

  a {
    font-weight: var(--fw-medium);
    color: var(--primary);
  }
`;
